<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

        <div>
            <tabsComp :tabs="tabs" />

            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:-10px !important;`">
                <v-row class="mt-10">
                    <v-col
                    cols="12"
                    md="10"
                    sm="12">
                    <form autocomplete="off">
                    <v-row>
                        <v-col cols="12" md="2" sm="12">
                        <label>{{lang.select_store}}</label>
                        <b-input-group>
                            <b-form-select
                            class="selborder"
                            v-model="store_id"
                            :options="storesVals"
                            ></b-form-select>
                            <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                <i class="fas fa-arrow-down"></i>
                            </b-input-group-append>
                        </b-input-group>
                        </v-col>
                        <v-col cols="12" md="2" sm="12">
                        <label></label>
                        <b-input-group>
                            <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;"  @click="getReport()">{{lang.search}}</b-button>
                        </b-input-group>
                        </v-col>
                    </v-row>
                    <b-input-group class="mt-3" style="display:none;">
                        <b-form-input placeholder="Start Date" onfocus="(this.type='date')" style="direction:rtl;border:1px solid #000;border-radius: 0;" type="date" v-model="sdate" :title="lang.start_date"></b-form-input>
                        <b-form-input placeholder="End Date" onfocus="(this.type='date')" style="border:1px solid #000" type="date" v-model="edate" :title="lang.end_date"></b-form-input>
                        <b-form-input :placeholder="lang.mobile"  style="border:1px solid #000" v-model="mobile"></b-form-input>
                        <b-form-input :placeholder="lang.plate_number" style="border:1px solid #000" v-model="plate_number"></b-form-input>
                        <b-input-group-append style="border:1px solid #000">
                        <!-- <b-button variant="light" style="background:gold;"  @click="getCurrentCards()"><i class="fas fa-search"></i></b-button> -->
                        <b-button variant="light" style="background:black;color:#fff"  @click="getCurrentCards()">{{lang.search}}</b-button>
                        </b-input-group-append>

                    </b-input-group>
                    </form>
                    </v-col>
                    <v-col
                    cols="12"
                    md="100"
                    style="margin-bottom:80px;"
                    sm="12">
                    <v-data-table
                        :headers="headers"
                        :items="tbRows"
                        hide-default-footer
                        disable-pagination
                    >
                        <template v-slot:header="" >
                            <thead>
                                <tr>
                                    <th class="text-center" colspan="10" style="font-weight:bold;font-size:1rem;">{{ lang.inventory_report }}</th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="row">
                            <tr>
                                <td class="text-center" style="width:70px">{{ row.item.item_code }}</td>
                                <td class="text-center" style="">{{ row.item[`item_name${lang.langname}`] }}</td>
                                <td class="text-center" style="width:70px">{{ $RoundNum(row.item.costs,2) }}</td>
                                <td class="text-center" style="width:70px">{{ $RoundNum(row.item.qtty,2) }}</td>
                                <td class="text-center" style="width:70px">{{ $RoundNum(parseFloat(row.item.qtty) * parseFloat(row.item.costs),2) }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    </v-col>
                </v-row>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue';
import ExportsPrint from '@/components/exports-print.vue';
import Footer from '@/components/Footer.vue';
import tabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default {
    components: {
        ExportsPrint, Footer, tabsComp, HeaderPortrate
    },
    data() {
        return {
            tbRows: [],
            store_id: 0,
            stores: [],
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
      storesVals: function(){
        let t =[];
        for(let i=0;i<this.stores.length;i++){
            t.push({
                text: this.stores[i][`name_${this.lang.langname}`],
                value: this.stores[i].id
            })
        }
        return t;
      },
      headers: function(){
        return [
            {
                text: this.lang.item_code,
                align: 'center',
                sortable: false,
                value: 'item_number',
                class:"backBlack",
                printRemove: 0
            },
            {
                text: this.lang.item_name,
                align: 'center',
                sortable: false,
                value: 'item_name',
                class:"backBlack",
                printRemove: 0,
            },
            {
                text: this.lang.cost_price,
                align: 'center',
                sortable: false,
                value: 'cost',
                class:"backBlack",
                printRemove: 0,
            },
            {
                text: this.lang.qtty,
                align: 'center',
                sortable: false,
                value: 'parent_class_name',
                class:"backBlack",
                printRemove: 0,
            },
            {
                text: this.lang.total,
                align: 'center',
                sortable: false,
                value: 'type',
                class:"backBlack",
                printRemove: 0,
            },

        ]
      },
      tabs: function() {

          return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

      },
    },
    methods:{
        collectSearch(){
            return {
                module: 'inventoryReport',
                elements: {
                    store_id: this.store_id
                }
            }
        },
        getStores() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getStores");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',-1);
            let myar = [];
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.stores = res.results.data;
                if(!this.store_id && this.stores.length > 0){
                    this.store_id = this.stores[0].id;
                }
            })
        },
        getReport(){
            const post = new FormData();
            post.append('type','getInventoryReport');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[store_id]',this.store_id);

            this.$store.state.showLoading = true
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.$store.state.showLoading = false
                const res = response.data;


                this.tbRows = res.results.data;
            });
        }
    },
    created(){
        this.getStores()
    }
}
</script>
